<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.branchName')
            }}</label>
            <ts-branch-filter @filter="setBranchList" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.academicYear')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acYearId"
              :options="acYearOptions"
              @change="getTerm"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.mainProgram')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acpId"
              :options="mainProgram"
              @change="() => (acTermId = null)"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.academicTerm')
            }}</label>
            <a-select
              style="width:100%"
              v-model="acTermId"
              :options="listOfTerm"
            ></a-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="ts-text-xs">{{
              $t('studentScoringEntry.scoringCycle')
            }}</label>
            <a-select style="width:100%" v-model="cycle">
              <a-select-option :value="1">{{
                $t('studentscoringentry.monthlyScore')
              }}</a-select-option>
              <a-select-option :value="0">{{
                $t('studentscoringentry.termlyScore')
              }}</a-select-option>
              <a-select-option :value="2">{{
                $t('studentscoringentry.semesterlyScore')
              }}</a-select-option>
            </a-select>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'drawerFilter',
  data () {
    return {
      loading: false,
      acYearOptions: [],
      mainProgram: [],
      termLists: []
    }
  },
  created () {
    this.fetchAcYear()
  },
  computed: {
    cycle: {
      get () {
        return this.$store.state.studentScoringEntry.scoring_cycle_id
      },
      set (newValue) {
        this.$store.commit('studentScoringEntry/SET_SCORING_CYCLE_ID', newValue)
      }
    },
    acYearId: {
      get () {
        return this.$store.state.studentScoringEntry.ac_year_id
      },
      set (newValue) {
        this.$store.commit('studentScoringEntry/SET_AC_YEAR_ID', newValue)
      }
    },
    acpId: {
      get () {
        return this.$store.state.studentScoringEntry.acp_id
      },
      set (newValue) {
        this.$store.commit('studentScoringEntry/SET_MAIN_PROGRAM', newValue)
      }
    },
    acTermId: {
      get () {
        return this.$store.state.studentScoringEntry.ac_term_id
      },
      set (newValue) {
        this.$store.commit('studentScoringEntry/SET_AC_TERM_ID', newValue)
      }
    },
    listOfTerm () {
      return this.termLists
        .filter(t => t.acp_id == this.acpId)
        .map(el => ({
          value: el.ac_term_id,
          label: el.term_name
        }))
    }
  },
  methods: {
    async fetchAcYear () {
      this.loading = true
      await this.$store
        .dispatch('academicYear/fetch', {
          fields: {
            academic_years: 'ac_year_id,ac_year'
          },
          page: -1
        })
        .then(response => {
          this.acYearOptions = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('mainProgram/fetch', {
          fields: {
            academic_program_mains: 'acp_id,acp_name_foreign'
          },
          page: -1
        })
        .then(response => {
          this.mainProgram = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
    setBranchList (branch) {
      this.$store.commit('studentScoringEntry/SET_BRANCH_LIST', branch)
    },
    getTerm (ac_year_id) {
      this.acpId = null
      this.acTermId = null
      this.loading = true
      this.$store
        .dispatch('termSemester/fetch', {
          include: 'sub_program',
          fields: {
            academic_terms: 'ac_term_id,term_name,acps_id'
          },
          filter: {
            ac_year_id: ac_year_id
          },
          page: -1
        })
        .then(response => {
          this.termLists = response.data.map(el => ({
            ac_term_id: el.ac_term_id,
            term_name: el.term_name,
            acp_id: el.sub_program.acp_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
